import { apiGetRechargeAddress, apiGetRechargeSubscriberData, apiGetRechargeSubscriptions, apiGetRechargeUpcomingOrder, } from "Root/api/apiRecharge";
export const createRechargeSlice = (set, get) => ({
    shopifyProducts: [],
    setShopifyProducts: (shopifyProducts) => set({ shopifyProducts }),
    subscriptions: [],
    setSubscriptions: (subscriptions) => set({ subscriptions }),
    upcomingOrder: null,
    setUpcomingOrder: (order) => set({ upcomingOrder: order }),
    orderHistory: [],
    setOrderHistory: (orderHistory) => set({ orderHistory }),
    address: {
        id: 0,
        address1: "",
        address2: null,
        city: "",
        country: "",
        first_name: "",
        last_name: "",
        province: "",
        zip: "",
        phone: null,
    },
    setAddress: (address) => set({ address }),
    subscriberData: {
        billing_address1: "",
        billing_address2: "",
        billing_city: "",
        billing_country: "",
        billing_province: "",
        billing_zip: "",
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
    },
    setSubscriberData: (data) => set({ subscriberData: data }),
    fetchRechargeSubscriptions: async () => {
        const { subscriptions } = await apiGetRechargeSubscriptions();
        set({ subscriptions });
    },
    fetchRechargeUpcomingOrder: async () => {
        const response = await apiGetRechargeUpcomingOrder();
        set({ upcomingOrder: response.charges[0] });
    },
    fetchRechargeAddress: async () => {
        const response = await apiGetRechargeAddress();
        set({ address: response });
    },
    fetchRechargeSubscriberData: async () => {
        const response = await apiGetRechargeSubscriberData();
        set({ subscriberData: response });
    }
});
